import { useField } from "formik";

import "../Forms.scss";

/**
 * SelectInput component
 * @param {{
 *   name: string,
 *   values: {label: string, value: string,disabled?: boolean}[],
 *   label?: string,
 *   disabled?: boolean,
 *   bottomText?: string,
 *   className?: string,
 *   onChange?: (value: string) => void
 * }} props
 * @returns
 */
function SelectInput({
  name,
  label,
  values,
  disabled,
  bottomText,
  className,
  onChange,
}) {
  const [field, meta] = useField(name);

  function handleChange(e) {
    if (onChange) {
      onChange(e.target.value);
    } else {
      field.onChange(e);
    }
  }

  return (
    <div
      className={`input ${className} ${
        meta.touched && meta.error ? "error" : ""
      }`}
    >
      {label ? <label htmlFor={name}>{label}</label> : null}

      <div className="input-field">
        <select
          {...field}
          value={field.value || ""}
          name={name}
          id={name}
          disabled={disabled}
          onChange={handleChange}
        >
          {values.map((v, k) => (
            <option
              key={k}
              value={v.value}
              disabled={v.disabled}
            >
              {v.label}
            </option>
          ))}
        </select>
      </div>

      <div className="meta">
        {meta.touched && meta.error ? (
          <small className="error-msg">{meta.error}</small>
        ) : null}
        {bottomText ? <small>{bottomText}</small> : null}
      </div>
    </div>
  );
}

export default SelectInput;
